import { render, staticRenderFns } from "./FormModel.vue?vue&type=template&id=0bc16db9&"
import script from "./FormModel.vue?vue&type=script&lang=js&"
export * from "./FormModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports